"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Distributor_1 = __importDefault(require("./Distributor"));
const Project_1 = __importDefault(require("./Project"));
const Sample_1 = __importDefault(require("./Sample"));
const emptyData = {
    samples: [],
    distributors: [],
    projects: [],
};
class AccessData {
    constructor(data = emptyData) {
        this.itemsPerPageClient = 10;
        this.currentPage = 1;
        this.samplesPagination = [];
        this.projectsPagination = [];
        this.distributors =
            data.distributors.map((distributor) => new Distributor_1.default(distributor)) || emptyData.distributors;
        this.samples =
            data.samples.map((sample) => new Sample_1.default(sample)) ||
                emptyData.samples;
        this.projects =
            data.projects.map((project) => new Project_1.default(project)) ||
                emptyData.projects;
    }
    allCropByDimension(dimension) {
        const filterCrops = new Set();
        const addUniqueCrop = (crop) => {
            const existingCrops = Array.from(filterCrops);
            const isUnique = !existingCrops.some((c) => c.id === crop.id);
            if (isUnique) {
                filterCrops.add(crop);
            }
        };
        if (dimension === 'samples') {
            this.samples.forEach((sample) => addUniqueCrop(sample.crop));
        }
        else {
            this.projects.forEach((project) => addUniqueCrop(project.crop));
        }
        return Array.from(filterCrops);
    }
    filterSampleForId(id) {
        const sampleFilter = this.samples.filter((sample) => {
            return sample.meta.id === id;
        });
        return sampleFilter[0].meta.code;
    }
    filterProjectForId(id) {
        const projectFilter = this.projects.filter((project) => {
            return project.meta.id === id;
        });
        return projectFilter[0].meta.name;
    }
    filterDistributorForId(id) {
        const distributorFilter = this.distributors.filter((distributor) => {
            return distributor.id === id;
        });
        return distributorFilter[0].code;
    }
    filterSamplesForIds(samplesIds) {
        const samplesCodes = [];
        const samplesFilter = this.samples.filter((sample) => {
            if (samplesIds.includes(sample.meta.id))
                return true;
            return false;
        });
        for (const sample of samplesFilter) {
            samplesCodes.push(sample.meta.code);
        }
        return samplesCodes.length > 5
            ? samplesCodes.slice(0, 5).join(', ') + ' ...'
            : samplesCodes.slice(0, 5).join(', ');
    }
    filterProjectsForIds(projectsIds) {
        const projectsCodes = [];
        const projectsFilter = this.projects.filter((project) => {
            if (projectsIds.includes(project.meta.id))
                return true;
            return false;
        });
        for (const project of projectsFilter) {
            projectsCodes.push(project.meta.name);
        }
        return projectsCodes.length > 5
            ? projectsCodes.slice(0, 5).join(', ') + ' ...'
            : projectsCodes.slice(0, 5).join(', ');
    }
    filterDistributorsForIds(distributorsIds) {
        const distributorsCodes = [];
        const distributorsFilter = this.distributors.filter((distributor) => {
            if (distributorsIds.includes(distributor.id))
                return true;
            return false;
        });
        for (const distributor of distributorsFilter) {
            distributorsCodes.push(distributor.code);
        }
        return distributorsCodes.length > 5
            ? distributorsCodes.slice(0, 5).join(', ') + ' ...'
            : distributorsCodes.slice(0, 5).join(', ');
    }
    get samplesTotalPages() {
        return Math.ceil(this.samples.length / 10);
    }
    get projectsTotalPages() {
        return Math.ceil(this.projects.length / 10);
    }
    get samplesPgi() {
        return this.samplesPagination;
    }
    get projectsPgi() {
        return this.projectsPagination;
    }
    setCurrentPage(page, dimension) {
        this.currentPage = page;
        this.paginatedItems(dimension);
    }
    paginatedItems(dimension) {
        if (dimension === 'samples') {
            if (this.samplesTotalPages > 1) {
                const samples = [];
                let samplesPagination = [];
                this.samples.forEach((element) => {
                    samples.push(element);
                });
                if (this.currentPage === 1) {
                    samplesPagination = samples.slice(0, this.itemsPerPageClient);
                }
                else {
                    samplesPagination = samples.slice(this.currentPage * this.itemsPerPageClient -
                        this.itemsPerPageClient, this.currentPage * this.itemsPerPageClient);
                }
                this.samplesPagination = samplesPagination;
            }
            else {
                this.samplesPagination = this.samples;
            }
        }
        else {
            if (this.projectsTotalPages > 1) {
                const projects = [];
                let projectsPagination = [];
                this.projects.forEach((element) => {
                    projects.push(element);
                });
                if (this.currentPage === 1) {
                    projectsPagination = projects.slice(0, this.itemsPerPageClient);
                }
                else {
                    projectsPagination = projects.slice(this.currentPage * this.itemsPerPageClient -
                        this.itemsPerPageClient, this.currentPage * this.itemsPerPageClient);
                }
                this.projectsPagination = projectsPagination;
            }
            else {
                this.projectsPagination = this.projects;
            }
        }
    }
    filterDistributorsByAccessSample(sampleId, filter) {
        if (filter === 'with access') {
            const sampleSelected = this.samples.filter((sample) => {
                if (sample.meta.id === sampleId)
                    return true;
                return false;
            });
            const distributorsIncludes = sampleSelected[0].distributorsAccess;
            return this.distributors.filter((distributor) => {
                if (distributorsIncludes.includes(distributor.id))
                    return true;
                return false;
            });
        }
        if (filter === 'without access') {
            const sampleSelected = this.samples.filter((sample) => {
                if (sample.meta.id === sampleId)
                    return true;
                return false;
            });
            const distributorsIncludes = sampleSelected[0].distributorsAccess;
            return this.distributors.filter((distributor) => {
                if (distributorsIncludes.includes(distributor.id))
                    return false;
                return true;
            });
        }
    }
    filterDistributorsByAccessProject(projectId, filter) {
        if (filter === 'with access') {
            const projectSelected = this.projects.filter((project) => {
                if (project.meta.id === projectId)
                    return true;
                return false;
            });
            const distributorsIncludes = projectSelected[0].distributorsAccess;
            return this.distributors.filter((distributor) => {
                if (distributorsIncludes.includes(distributor.id))
                    return true;
                return false;
            });
        }
        if (filter === 'without access') {
            const projectSelected = this.projects.filter((project) => {
                if (project.meta.id === projectId)
                    return true;
                return false;
            });
            const distributorsIncludes = projectSelected[0].distributorsAccess;
            return this.distributors.filter((distributor) => {
                if (distributorsIncludes.includes(distributor.id))
                    return false;
                return true;
            });
        }
    }
    filterDistributorsByAccessSamples(ids, filter) {
        if (filter === 'with access') {
            const selectedSamples = [];
            for (const sample of this.samples) {
                if (ids.includes(sample.meta.id)) {
                    selectedSamples.push(sample);
                }
            }
            const distributorsFilters = [];
            for (const dist of this.distributors) {
                let estaEnTodasLasMuestras = true;
                for (const sampleSelect of selectedSamples) {
                    if (!sampleSelect.distributorsAccess.includes(dist.id)) {
                        estaEnTodasLasMuestras = false;
                        break;
                    }
                }
                if (estaEnTodasLasMuestras) {
                    distributorsFilters.push(dist);
                }
            }
            return distributorsFilters;
        }
        else {
            const selectedSamples = [];
            for (const sample of this.samples) {
                if (ids.includes(sample.meta.id)) {
                    selectedSamples.push(sample);
                }
            }
            const distributorsFiltersSamples = [];
            for (const dist of this.distributors) {
                let noEstaEnNingunaMuestra = true;
                for (const sampleSelect of selectedSamples) {
                    if (sampleSelect.distributorsAccess.includes(dist.id)) {
                        noEstaEnNingunaMuestra = false;
                        break;
                    }
                }
                if (noEstaEnNingunaMuestra) {
                    distributorsFiltersSamples.push(dist);
                }
            }
            return distributorsFiltersSamples;
        }
    }
    filterDistributorsByAccessProjects(ids, filter) {
        if (filter === 'with access') {
            const selectedProjects = [];
            for (const project of this.projects) {
                if (ids.includes(project.meta.id)) {
                    selectedProjects.push(project);
                }
            }
            const distributorsFilters = [];
            for (const dist of this.distributors) {
                let estaEnTodasLasMuestras = true;
                for (const projectSelect of selectedProjects) {
                    if (!projectSelect.distributorsAccess.includes(dist.id)) {
                        estaEnTodasLasMuestras = false;
                        break;
                    }
                }
                if (estaEnTodasLasMuestras) {
                    distributorsFilters.push(dist);
                }
            }
            return distributorsFilters;
        }
        else {
            const selectedProjects = [];
            for (const project of this.projects) {
                if (ids.includes(project.meta.id)) {
                    selectedProjects.push(project);
                }
            }
            const distributorsFiltersSamples = [];
            for (const dist of this.distributors) {
                let noEstaEnNingunaMuestra = true;
                for (const projectSelect of selectedProjects) {
                    if (projectSelect.distributorsAccess.includes(dist.id)) {
                        noEstaEnNingunaMuestra = false;
                        break;
                    }
                }
                if (noEstaEnNingunaMuestra) {
                    distributorsFiltersSamples.push(dist);
                }
            }
            return distributorsFiltersSamples;
        }
    }
    filterSamples(textSearch, cropsIds, filterAccess) {
        return this.samples.filter((sample) => {
            if (filterAccess.length > 0) {
                if (filterAccess === 'access') {
                    return sample.distributorsAccess.length > 0;
                }
                else {
                    return sample.distributorsAccess.length < 1;
                }
            }
            else if (cropsIds.length > 0) {
                return cropsIds.includes(sample.crop.id);
            }
            else {
                return (sample.meta.name
                    .toLowerCase()
                    .includes(textSearch.trim().toLowerCase()) ||
                    sample.meta.code
                        .toLowerCase()
                        .includes(textSearch.trim().toLowerCase()));
            }
        });
    }
    filterProjects(textSearch, cropsIds, filterAccess) {
        return this.projects.filter((project) => {
            if (filterAccess.length > 0) {
                if (filterAccess === 'access') {
                    return project.distributorsAccess.length > 0;
                }
                else {
                    return project.distributorsAccess.length < 1;
                }
            }
            else if (cropsIds.length > 0) {
                return cropsIds.includes(project.crop.id);
            }
            else {
                return (project.meta.name
                    .toLowerCase()
                    .includes(textSearch.trim().toLowerCase()) ||
                    project.meta.code
                        .toLowerCase()
                        .includes(textSearch.trim().toLowerCase()));
            }
        });
    }
}
exports.default = AccessData;
